import React from 'react';

export interface DateRangeFilterProps {
  startDate: string;
  endDate: string;
  onStartDateChange: (value: string) => void;
  onEndDateChange: (value: string) => void;
  label?: string;
  startDateId?: string;
  endDateId?: string;
  startDateAriaLabel?: string;
  endDateAriaLabel?: string;
}

/**
 * DateRangeFilter - 기간 필터 컴포넌트
 * 시작일과 종료일을 입력받아 필터링할 수 있는 재사용 가능한 컴포넌트
 */
export const DateRangeFilter: React.FC<DateRangeFilterProps> = ({
  startDate,
  endDate,
  onStartDateChange,
  onEndDateChange,
  label = '기간',
  startDateId = 'startDateInput',
  endDateId = 'endDateInput',
  startDateAriaLabel = '시작 날짜',
  endDateAriaLabel = '종료 날짜',
}) => {
  return (
    <div className="flex items-center gap-2">
      <label htmlFor={startDateId} className="text-sm whitespace-nowrap text-slate-500">
        {label}
      </label>
      <input
        id={startDateId}
        type="date"
        value={startDate}
        onChange={(e) => onStartDateChange(e.target.value)}
        aria-label={startDateAriaLabel}
        className="rounded-lg border border-slate-200 bg-white px-3 py-2 text-sm text-slate-700 focus:border-transparent focus:ring-2 focus:ring-blue-500 focus:outline-none"
      />
      <span className="text-slate-400">~</span>
      <input
        id={endDateId}
        type="date"
        value={endDate}
        onChange={(e) => onEndDateChange(e.target.value)}
        aria-label={endDateAriaLabel}
        className="rounded-lg border border-slate-200 bg-white px-3 py-2 text-sm text-slate-700 focus:border-transparent focus:ring-2 focus:ring-blue-500 focus:outline-none"
      />
    </div>
  );
};
